import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { AshIcon } from "@jti/brand-icons/ash";
import { CreditCardBlockedIcon } from "@jti/brand-icons/credit-card-blocked";
import { EditIcon } from "@jti/brand-icons/edit";
import { IngredientsFibersIcon } from "@jti/brand-icons/ingredients-fibers";
import { IngredientsFlavoringIcon } from "@jti/brand-icons/ingredients-flavoring";
import { IngredientsGumbaseIcon } from "@jti/brand-icons/ingredients-gumbase";
import { IngredientsNicotineIcon } from "@jti/brand-icons/ingredients-nicotine";
import { LockOutlineCloseIcon } from "@jti/brand-icons/lock-outline-close";
import { MouthTingleIcon } from "@jti/brand-icons/mouth-tingle";
import { MouthUnderLipIcon } from "@jti/brand-icons/mouth-under-lip";
import { NoiseAndSmokeIcon } from "@jti/brand-icons/noise-and-smoke";
import { PackageIcon } from "@jti/brand-icons/package";
import { PackageArrowIcon } from "@jti/brand-icons/package-arrow";
import { PackageCheckIcon } from "@jti/brand-icons/package-check";
import { PackageReturnIcon } from "@jti/brand-icons/package-return";
import { PackageShoppingIcon } from "@jti/brand-icons/package-shopping";
import { PackageTimeIcon } from "@jti/brand-icons/package-time";
import { PinTimePlaceIcon } from "@jti/brand-icons/pin-time&place";
import { PlusFallingIcon } from "@jti/brand-icons/plus-falling";
import { PouchDisposeIcon } from "@jti/brand-icons/pouch-dispose";
import { ProfileDefaultIcon } from "@jti/brand-icons/profile-default";
import { ProfileFamilyIcon } from "@jti/brand-icons/profile-family";
import { SmokeIcon } from "@jti/brand-icons/smoke";
import { StarsShinningIcon } from "@jti/brand-icons/stars-shinning";
import { TimerIcon } from "@jti/brand-icons/timer";
import { TobaccoLeafIcon } from "@jti/brand-icons/tobacco-leaf";
import { ToolsNoToolIcon } from "@jti/brand-icons/tools-no_tool";
import { UiCheckCircleIcon } from "@jti/brand-icons/ui-check-circle";
import { UiCheckplusCircleIcon } from "@jti/brand-icons/ui-checkplus-circle";
import { LinkBehaviour } from "../LinkBehaviour";
import styles from "./EcommerceReassuranceBanner.module.scss";
export const icons = {
    account: _jsx(ProfileDefaultIcon, {}),
    cardWithLock: _jsx(CreditCardBlockedIcon, {}),
    checkMarkWithRoundBorder: _jsx(UiCheckCircleIcon, {}),
    checkPlusCircle: _jsx(UiCheckplusCircleIcon, {}),
    easyToMaintain: _jsx(ToolsNoToolIcon, {}),
    edit: _jsx(EditIcon, {}),
    falling: _jsx(PlusFallingIcon, {}),
    ingredientFibers: _jsx(IngredientsFibersIcon, {}),
    ingredientFlavoring: _jsx(IngredientsFlavoringIcon, {}),
    ingredientGumbase: _jsx(IngredientsGumbaseIcon, {}),
    ingredientNicotine: _jsx(IngredientsNicotineIcon, {}),
    lockOutlineClose: _jsx(LockOutlineCloseIcon, {}),
    minimalCleaning: _jsx(StarsShinningIcon, {}),
    mouthTingle: _jsx(MouthTingleIcon, {}),
    mouthUnderLip: _jsx(MouthUnderLipIcon, {}),
    noAsh: _jsx(AshIcon, {}),
    noSmokeSmell: _jsx(NoiseAndSmokeIcon, {}),
    package: _jsx(PackageIcon, {}),
    packageReturn: _jsx(PackageReturnIcon, {}),
    packageShopping: _jsx(PackageShoppingIcon, {}),
    packageWithArrow: _jsx(PackageArrowIcon, {}),
    packageWithCheckMark: _jsx(PackageCheckIcon, {}),
    packageWithClock: _jsx(PackageTimeIcon, {}),
    pinTimePlace: _jsx(PinTimePlaceIcon, {}),
    pleasantAroma: _jsx(SmokeIcon, {}),
    pouchDispose: _jsx(PouchDisposeIcon, {}),
    profileFamily: _jsx(ProfileFamilyIcon, {}),
    timer: _jsx(TimerIcon, {}),
    tobaccoLeaf: _jsx(TobaccoLeafIcon, {}),
};
export const EcommerceReassuranceBanner = ({ items, theme }) => {
    const themeClass = {
        light: "light-theme",
        dark: "dark-theme",
    };
    return (_jsx("ul", { className: classNames(styles.container, themeClass[theme]), children: items.map(({ description, iconName, id, href }) => (_jsxs("li", { className: classNames(styles.item), children: [_jsx("span", { className: styles.iconWrapper, "data-testid": "ecommerceReassuranceBanner-icon", children: icons[iconName] }), _jsx("span", { className: styles.description, children: description }), href && _jsx(LinkBehaviour, { href: href, className: styles.link })] }, id))) }));
};
//# sourceMappingURL=EcommerceReassuranceBanner.js.map